import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import PropTypes from "prop-types";
import { TabPanel } from "./tab-panel.es.js";
import { tabsContext } from "./tabs-context.es.js";
const propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired
};
const TabPanelActive = ({ children }) => {
  const [activeKey] = useContext(tabsContext);
  return /* @__PURE__ */ jsx(TabPanel, { tabKey: activeKey, children: typeof children === "function" ? children(activeKey) : children });
};
TabPanelActive.propTypes = propTypes;
export {
  TabPanelActive
};
